import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M16.103 4.667c-2.698 0-4.28 1.388-4.28 4.55V12H8.4v3.333h3.423v8h3.422v-8h2.738L18.667 12h-3.422V9.781c0-1.191.399-1.78 1.547-1.78h1.875V4.802a22 22 0 0 0-2.564-.136"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "facebook"}) } }